import { ApiConfig } from '@/types/api';
import { runtimeConfig } from '@/config/runtime';

export const apiConfig: ApiConfig = {
  baseUrl: runtimeConfig.apiUrl,
  timeout: 15000,
  retries: 1,
};

const REST = '/rest';

export const REST_ENDPOINTS = {
  PRICES: `${REST}/prices`,
  FACILITIES: `${REST}/facilities`,
  FACILITY_BY_CODE: (facilityCode: string) => `${REST}/facilities/${facilityCode}`,
  FACILITY_STAT: (facilityCode: string) => `${REST}/facilities/${facilityCode}/stat`,
  FACILITY_UNITS: (facilityCode: string) => `${REST}/facilities/${facilityCode}/units`,
  FACILITY_UNIT_TYPES: (facilityCode: string) => `${REST}/facilities/${facilityCode}/unitTypes`,
  FACILITY_UNIT_TYPE: (facilityCode: string, unitType: string) =>
    `${REST}/facilities/${facilityCode}/unitTypes/${unitType}`,
  FACILITY_UNIT_TYPE_UNITS: (facilityCode: string, unitType: string) =>
    `${REST}/facilities/${facilityCode}/unitTypes/${unitType}/units`,
  FACILITY_UNIT: (facilityCode: string, unitType: string, unitCode: string) =>
    `${REST}/facilities/${facilityCode}/unitTypes/${unitType}/units/${unitCode}`,

  ACCOUNTS_EMAIL_AVAILABLE: `${REST}/accounts/email-available`,
  ACCOUNTS_FORGOT_PASSWORD: `${REST}/accounts/forgot-password`,
  ACCOUNTS_RESTORE_PASSWORD: `${REST}/accounts/restore-password`,
  CUSTOMERS_REGISTER: `${REST}/customers`,
} as const;

export const ACCOUNT_ENDPOINTS = {
  LOGIN: '/accounts/login',
  CUSTOMER_LOGIN: (customerId: number) => `/account/customers/${customerId}/login`,
  CUSTOMER_LOGOUT: '/customers/logout',
  EMAIL_AVAILABLE: REST_ENDPOINTS.ACCOUNTS_EMAIL_AVAILABLE,
  ME: '/account/me',
  ME_CUSTOMERS: '/account/customers',
  ME_FORGOT_PASSWORD: REST_ENDPOINTS.ACCOUNTS_FORGOT_PASSWORD,
  ME_RESTORE_PASSWORD: REST_ENDPOINTS.ACCOUNTS_RESTORE_PASSWORD,
} as const;

export const CUSTOMER_ENDPOINTS = {
  REGISTER: REST_ENDPOINTS.CUSTOMERS_REGISTER,
  ME: '/customers/me',
  PASSWORD: '/customers/password',
  ME_ACCOUNTS: '/customers/accounts',
  ME_ACCOUNT_BY_ID: (accountId: number) => `/customers/accounts/${accountId}`,
} as const;

export const CONTRACT_ENDPOINTS = {
  CONTRACTS: '/customers/contracts',
  CONTRACT_BY_ID: (contractId: number) => `/customers/contracts/${contractId}`,
  CONTRACT_RECURRENT: (contractId: number) => `/customers/contracts/${contractId}/recurrent`,
  CREATE_CONTRACT: '/customers/contracts/unit',
} as const;

export const INVOICE_ENDPOINTS = {
  INVOICES: '/customers/invoices',
  INVOICE_BY_ID: (invoiceId: number) => `/customers/invoices/${invoiceId}`,
} as const;

export const DOCUMENT_ENDPOINTS = {
  CUSTOMER_DOCUMENT: (
    resource: 'contracts' | 'invoices',
    resourceId: number,
  ) => `/customers/documents/${resource}/${resourceId}`,
} as const;

export const PAYMENT_ENDPOINTS = {
  PAYMENT_OPTIONS: '/customers/payment-methods',
  PAYMENTS: '/customers/payments',
  PAYMENT_BY_ID: (paymentId: string) => `/customers/payments/${paymentId}`,
  VAULT: '/customers/vault',
  VAULT_METHOD_BY_ID: (methodId: string) => `/customers/vault/${methodId}`,
} as const;

export const GUARD_ENDPOINTS = {
  PIN_CODES: '/customers/pin-codes',
} as const;

export const WAREHOUSE_ENDPOINTS = {
  FACILITIES: REST_ENDPOINTS.FACILITIES,
  FACILITY_BY_CODE: REST_ENDPOINTS.FACILITY_BY_CODE,
  FACILITY_UNITS: REST_ENDPOINTS.FACILITY_UNITS,
  FACILITY_UNIT_TYPES: REST_ENDPOINTS.FACILITY_UNIT_TYPES,
  FACILITY_UNIT_TYPE: REST_ENDPOINTS.FACILITY_UNIT_TYPE,
  FACILITY_UNIT_TYPE_UNITS: REST_ENDPOINTS.FACILITY_UNIT_TYPE_UNITS,
  FACILITY_UNIT: REST_ENDPOINTS.FACILITY_UNIT,
  FACILITY_PUBLIC_STATISTICS: REST_ENDPOINTS.FACILITY_STAT,
} as const;